<template>
  <div class="wgtSettings" :class="{ 'isTableShown': isShowTable }">
    <div class="cardR">
      <div class="boxR">
        <div class="myZoomClass" :class="$store.state.TClrs" id="worldmapsnap">
          <div class="content-panel1" v-show="IsworldErr">
            <h2 class="chartTitle hide-on-presentation themeclr2">Timezone Distribution</h2>
            <apiErrorComponent @tryReload="tryReload" compTitle="Timezone Distribution" compId="worldmapsnap">
            </apiErrorComponent>
          </div>
          <div class="content-panel1" v-show="!IsworldErr">
            <div class="insideL  hide-on-presentation ">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-bars" />
              </div>
              <div class="contents">
                <span v-show="!IsworldErr">
                  <font-awesome-icon icon="fa-solid fa-diagram-successor" title="Switch to Alternate View"
                    v-on:click="swapCharts()" />
                  <font-awesome-icon icon="fa-solid fa-table" v-on:click="showTable()"
                    :title="isShowTable ? 'Hide Table' : 'Show Table'" />
                  <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" v-on:click="addToSlider()"
                    title="Add to Storyboard" />
                  <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                    v-on:click="downloadDom()" />
                  <font-awesome-icon icon="fa-solid fa-file-export" title="Export Insights" v-on:click="downIns()" />
                </span>
              </div>
            </div>
            <div class="insideR hide-on-presentation">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-info" />
              </div>
              <div class="contents">
                {{ $parent.widgetInfo.world_map }}. You can click on individual countries to get more insights.
                <br />
                <br />
                Actions you can take on this widget: <br />
                <ul>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-diagram-successor" /> to swap between bar and
                    wordmap view
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-table" /> to see table with values
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" /> to add to storyboard
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" /> to download the chart with
                    current insight
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-export" /> to download all the insights
                  </li>
                </ul>
              </div>
            </div>
            <div v-show="!isLoadworld">
              <widgetLoadingComp></widgetLoadingComp>
            </div>
            <div v-show="isLoadworld"></div>
            <h2 class="chartTitle hide-on-presentation themeclr2">Timezone Distribution</h2>
            <div class="panel-body text-center " :class="{ 'BlurClass': !isLoadworld }" id="myPanelBody">
              <div id="containerMap" class="contmap" v-show="Isworldshw"> </div>
              <div v-if="isShowTable">
                <div v-on:click="onBtnExport()" class="myfaBtn spl">
                  <font-awesome-icon :icon="['fas', 'fa-download']" />
                </div>
                <ag-grid-vue style="width: 96%;height:470px;"
                  class="table-striped thmHead myMttrTbl v01 ag-theme-alpine myHomeTable" :columnDefs="asgcolsDefs"
                  @grid-ready="onAsgReady" :modules="modules">
                </ag-grid-vue>
              </div>
              <div v-if="IsworldData" class="widgetError text-center">
                <widgetDataMsg></widgetDataMsg>
              </div>
              <div v-if="IsworldErr">
                <widgetErrorImg></widgetErrorImg>
              </div>
            </div>
            <widgetsSlider class="mar30top" :insideArr="worldmapinsight" :isInsErr="IsworldErr"
              compTitle="Timezone Distribution" compId="worldmapsnap" :isErr="IsworldErr"></widgetsSlider>
          </div>
          <span data-balloon-length="xlarge" :aria-label="myMapDisclaimer" data-balloon-pos="up-right" class="discinfo">
            <i class="fas fa-exclamation-triangle cursor-pointer exminpt"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  useRoute
} from 'vue-router';
import * as echarts from 'echarts';
import domtoimage from "dom-to-image-more";
import {
  saveAs
} from 'file-saver';
import {
  AgGridVue
} from "@ag-grid-community/vue3";
import {
  ClientSideRowModelModule
} from "@ag-grid-community/client-side-row-model";
import {
  CsvExportModule
} from "@ag-grid-community/csv-export";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import widgetDataMsg from '../smallcomp/chartDataMsg.vue'
import widgetErrorImg from '../smallcomp/chartDataMsg.vue'
import worldData from "../../data/world.json"
import widgetLoadingComp from '../smallcomp/widgetloader.vue'
import screenShotMix from "./../../mixin/screenShotMix"
import apiErrorComponent from '../smallcomp/apierror.vue'
import widgetsSlider from '../smallcomp/widgets-slider.vue';
var myChartWorldMap
function reportWindowSizeWM() {
  if (myChartWorldMap != undefined) {
    myChartWorldMap.resize()
  }
}
export default {
  name: 'WorldMap',
  mixins: [screenShotMix],
  components: {
    widgetDataMsg,
    widgetErrorImg,
    widgetLoadingComp,
    AgGridVue,
    apiErrorComponent,
    widgetsSlider
  },
  props: {
    getPins: Object,
    tabname: String,
  },
  data() {
    return {
      modules: [ClientSideRowModelModule, CsvExportModule],
      asgLisApi: null,
      asgLis: null,
      asgcolsDefs: [],
      isShowTable: false,
      worldData: worldData,
      myMapDisclaimer: "Maps in this product are for informational purposes only and may not have been prepared for, or suitable for legal, engineering, or surveying purposes. LTIMindtree cannot be held responsible for the misuse or misinterpretation of any information and offers no warranty guarantees or representations of any kind in connection to its accuracy or completeness. LTIMindtree accepts no liability for any loss, damage or inconvenience caused as a result of reliance on the mapping.",
      worldmapinsight: [],
      isLoadworld: false,
      IsworldData: false,
      Isworldshw: false,
      IsworldErr: false,
      IswmInsErr: false,
      isWMshow: true,
      screenShort: {
        id: 'worldmapsnap',
        name: 'World-Map.png'
      },
      paginNo: 0,
      paginIdx: "transform: translateX(0%)",
      worldChartData: [],
      maxValue: 0,
      isChartRedraw: true,
    }
  },
  methods: {
    pagNav(index) {
      this.paginNo = index;
      this.paginIdx = "transform: translateX(-" + 5 * index + "%)"
    },
    tryReload() {
      this.getworld()
    },
    addToSlider() {
      let insArr = this.worldmapinsight;
      let name = "Timezone Distribution - " + this.getPins.viewName;
      let screenShort = {
        id: 'worldmapsnap',
        name: 'worldmapsnap.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    onAsgReady(params) {
      this.asgLisApi = params.api
      this.gridColumnApi = params.columnApi
      this.asgLisApi.setRowData(this.asgLis);
      params.api.sizeColumnsToFit();
    },
    onBtnExport() {
      this.asgLisApi.exportDataAsCsv();
    },
    percGetter(params) {
      return params.data.perc + '%'
    },
    myPercComparator(v1, v2, n1, n2) {
      v1 = parseFloat(v1.slice(0, -1))
      v2 = parseFloat(v2.slice(0, -1))
      return v1 - v2
    },
    numberValueFormatter(params) {
      return params.value.toLocaleString();
    },
    showTable() {
      if (this.isShowTable) {
        this.isShowTable = false
      } else {
        this.asgcolsDefs = [{
          headerName: 'Country',
          field: 'countryname',
          sortable: true
        },
        {
          headerName: '# Tickets',
          field: 'count',
          type: 'numericColumn',
          valueFormatter: this.numberValueFormatter,
          sortable: true
        },
        {
          headerName: 'Percentage',
          field: 'perc',
          type: 'numericColumn',
          comparator: this.myPercComparator,
          valueGetter: this.percGetter,
          sortable: true
        }
        ]
        this.isShowTable = true;
      }
    },
    downloadDom() {
      let imgname = "WorldMap_Chart.png"
      let widgetID = "worldmapsnap"
      var geticondiv = document.querySelectorAll('#worldmapsnap .insideL,#worldmapsnap .insideR, .hide-on-presentation')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          saveAs(blob, imgname)
          geticondiv.forEach(box => {
            box.style.opacity = 1;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        })
    },
    downIns() {
      let fileName = 'WorldMap_Insights.txt'
      let insArr = []
      insArr = this.worldmapinsight.join("\r\n");
      var fileToSave = new Blob([insArr], {
        type: 'application/json',
        name: fileName
      });
      saveAs(fileToSave, fileName)
    },
    swapCharts() {
      this.isWMshow = !this.isWMshow;
      setTimeout(() => {
        if (this.isWMshow) {
          this.drawWorld();
        } else {
          this.drawChart();
        }
      }, 500);
    },
    drawWorld() {
      var emit = this.$emit
      echarts.registerMap('World', worldData);
      let chartDomWM = document.getElementById('containerMap');
      if(chartDomWM == null) return;
      if (chartDomWM != null && chartDomWM != undefined) {
        if (this.isChartRedraw) {
          this.isChartRedraw = false;
          myChartWorldMap = echarts.init(chartDomWM);
        }
        for (let index = 0; index < this.worldChartData.length; index++) {
          const element = this.worldChartData[index];
          element.name = element.name.toLowerCase();
        }
        const mapOption = {
          tooltip: {
            confine: true,
            formatter: (params) => {
              if (params.value > 0) {
                return params.marker + params.name + ": " + params.value.toLocaleString() + "(" + params.data
                  .perc + "%)";
              }
            },
          },
          grid: {
            top: '2%',
            left: 120,
            right: 10,
            bottom: '2%',
          },
          xAxis: {
            show: false,
            data: null,
          },
          yAxis: {
            show: false,
            data: null,
          },
          visualMap: {
            top: 0,
            min: 0,
            max: this.maxValue,
            text: ['High', 'Low'],
            inRange: {
              color: this.$store.state.chartColor,
            },
            calculable: true,
            textStyle: {
              color: '#777',
              fontSize: 10
            },
          },
          series: [{
            id: 'population',
            name: '# Tickets',
            type: 'map',
            map: 'World',
            itemStyle: {
              areaColor: 'rgba(127,127,127,0.1)',
              borderWidth: 1,
              borderColor: '#777',
              opacity: 0.9
            },
            select: {
              disabled: true,
            },
            emphasis: {
              disabled: true,
              itemStyle: {
                opacity: 1,
                color: 'inherit'
              },
            },
            animationDurationUpdate: 1000,
            universalTransition: true,
            data: this.worldChartData
          }]
        };
        myChartWorldMap.setOption(mapOption);
        myChartWorldMap.on('click', function (params) {
          if (params.componentType === 'series' && params.data != undefined) {
            let clickitem = {
              "currpass": params.name,
              "filterop": "COUNTRY_NAME"
            }
            emit("getKDrill", clickitem)
          }
        })
      }
    },
    drawChart() {
      const barOption = {
        tooltip: {
          confine: true,
          formatter: (params) => {
            return params.marker + params.name + ": " + params.value + " ticket(s)";
          },
        },
        visualMap: {
          top: 0,
          min: 0,
          max: this.maxValue,
          inRange: {
            color: this.$store.state.chartColor,
          },
          dimension: 0, // the fourth dimension of series.data (i.e. value[3]) is mapped
          seriesIndex: 0, // The fourth series is mapped.
          calculable: true,
          textStyle: {
            color: '#777',
            fontSize: 10
          },
        },
        xAxis: {
          show: true,
          type: 'value',
          splitLine: {
            show: false
          },
          splitArea: {
            show: false
          },
          axisLine: {
            show: true
          },
          axisLabel: {
            color: "#777",
            fontSize: 10
          },
        },
        yAxis: {
          show: true,
          type: 'category',
          inverse: true,
          splitArea: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLine: {
            show: true
          },
          axisLabel: {
            color: "#777",
            fontSize: 10
          },
          data: this.worldChartData.map(function (item) {
            return item.name;
          })
        },
        series: {
          type: 'bar',
          id: 'population',
          data: this.worldChartData.map(function (item) {
            return item.value;
          }),
          animationDurationUpdate: 1000,
          universalTransition: true,
          itemStyle: {
            borderRadius: 2,
            opacity: 1,
          },
        }
      };
      myChartWorldMap.setOption(barOption);
    },
    getworld() {
      this.IsworldErr = false
      this.IsworldData = false
      this.Isworldshw = false
      this.IswmInsErr = false
      this.isLoadworld = false
      this.axios.post(this.uriApiUrl + 'DataAnalysis/get_worldchart?&asg_id=' + this.asgId, {
        "selid": this.getPins.selid,
        "edited": this.getPins.edited
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error" && response.data != "Nodata") {
              var worldchartresp = response.data
              this.asgLis = worldchartresp.table_view
              this.worldmapinsight = worldchartresp.insights
              this.Isworldshw = true
              if (this.worldmapinsight.length == 0) {
                this.IswmInsErr = true
              }
              this.maxValue = 0;
              this.worldChartData = [];
              for (let index = 0; index < worldchartresp.table_view.length; index++) {
                const element = worldchartresp.table_view[index];
                this.worldChartData.push({
                  "name": element.countryname,
                  "value": element.count,
                  "perc": element.perc == 0 ? '<1' : element.perc
                })
                if (element.count > this.maxValue) {
                  this.maxValue = element.count;
                }
              }
              if (this.isChartRedraw) {
                try {
                  echarts.dispose(myChartWorldMap);
                } catch (error) {
                  // console.log("..")
                }
              }
              setTimeout(() => {
                this.drawWorld()
              }, 5)
              this.isLoadworld = true
            } else if (response.data == "Nodata") {
              this.IsworldData = true
            } else if (response.data == "Error") {
              this.IsworldErr = true
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong in World Map. Try after sometime!'
              })
            }
          }
        }).catch((response) => {
          this.IsworldErr = true
          this.isLoadworld = true
          if (this.enabledDebug == 1) {
            this.$notify({
              type: "error",
              text: 'Sorry! Something went wrong in World Map. Try after sometime!'
            })
          }
        })
    }
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    this.getworld()
    this.isChartRedraw = true
    window.addEventListener("resize", reportWindowSizeWM);
  },
  unmounted() {
    window.removeEventListener("resize", reportWindowSizeWM);
  },
  watch: {
    '$store.state.chartColor': function () {
      if (myChartWorldMap != undefined) {
        this.drawWorld()
      }
    }
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.contmap {
  position: relative;
  height: 370px;
}

.discinfo {
  position: absolute !important;
  bottom: 215px;
  /* font-size: 15pt; */
  right: 45px;
}

.exminpt {
  font-size: 1rem;
}

.names {
  fill: none;
  stroke: #fff;
  stroke-linejoin: round;
}

.details {
  color: black;
}

.darkTheme .details {
  color: white;
}</style>